import React, { Component } from 'react';
import { Auth } from 'aws-amplify';

import Button from '@material-ui/core/Button';
import { Grid, TextField } from '@material-ui/core';
import { Face, Fingerprint } from '@material-ui/icons';
import Paper from '@material-ui/core/Paper';

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            loading: false
        };
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSubmit = async event => {
        event.preventDefault();

        // setIsLoading(true);
        this.setState({ loading: true });

        try {
            await Auth.signIn(this.state.email, this.state.password);
            this.props.userHasAuthenticated(true);
        } catch (e) {
            alert(e.message);
            this.setState({ loading: false });
        }
    };

    render() {
        return (
            <Paper elevation={3} style={{ width: 400, marginLeft: 'auto', marginRight: 'auto', padding: '2rem', marginTop: '10vh' }}>
                <Grid container alignItems="flex-end" spacing={2}>
                    <Grid item>
                        <Face />
                    </Grid>
                    <Grid item md={true} sm={true} xs={true}>
                        <TextField name="email" label="Username" type="email" fullWidth autoFocus required value={this.state.email} onChange={this.onChange} />
                    </Grid>
                </Grid>
                <Grid container alignItems="flex-end" spacing={2}>
                    <Grid item>
                        <Fingerprint />
                    </Grid>
                    <Grid item md={true} sm={true} xs={true}>
                        <TextField name="password" label="Password" type="password" fullWidth required value={this.state.password} onChange={this.onChange} />
                    </Grid>
                </Grid>
                <Grid container justify="center" style={{ marginTop: '10px' }}>
                    <Button variant="outlined" color="primary" style={{ textTransform: 'none' }} onClick={this.handleSubmit}>
                        Login
                    </Button>
                </Grid>
            </Paper>
        );
    }
}
